<template>
  <div/>
</template>

<script>
export default {
  mounted () {
    this.$cookie.set('session_id', '', { expires: '1s' })
    this.$router.push('login')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Logout.vue